import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseEntityResolver } from '@ishop/admin-ui/core';
import { Administrator, Role } from '@ishop/admin-ui/core';
import { DataService } from '@ishop/admin-ui/core';

@Injectable({
    providedIn: 'root',
})
export class ProfileResolver extends BaseEntityResolver<Administrator.Fragment> {
    constructor(router: Router, dataService: DataService) {
        super(
            router,
            {
                __typename: 'Administrator' as 'Administrator',
                id: '',
                createdAt: '',
                updatedAt: '',
                emailAddress: '',
                firstName: '',
                lastName: '',
                user: { roles: [] } as any,
            },
            id =>
                dataService.administrator
                    .getActiveAdministrator()
                    .mapStream(data => data.activeAdministrator),
        );
    }
}
